import React, { useState } from "react";
import * as XLSX from "xlsx";
import ModalCreaPase from './Modal';
import GenerarPaseDeSalida from "./GenerarPaseDeSalida";
import socket from "../tools/socke";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";
import comprueboPermisos from "../tools/comprueboPermisos";

const ListeaCarpetas = ({ carpetas, onClick, paso, carpetaFinal }) => {
  const Usuario = ObtieneDatosCookies();

  const [filtroFecha, setFiltroFecha] = useState("siempre");
  const [modalCreaPase, setModalCreaPase] = useState(false);
  const [datosPase, setDatosPase] = useState();

  const [ordenCampo, setOrdenCampo] = useState(null);
  const [ordenAscendente, setOrdenAscendente] = useState(true);

  const manejaCerradoPaseForm = () => {
    setModalCreaPase(false);
    socket.emit("carpetaEvent", "");
  };

  function getTodayDate() {
    const today = new Date();
    return today.toLocaleDateString("es-AR", { day: "2-digit", month: "2-digit", year: "2-digit" });
  }

  function getTimestamp(timestamp) {
    const date = new Date(timestamp);
    return date.toLocaleTimeString("es-AR", { hour: "2-digit", minute: "2-digit", day: "2-digit", month: "2-digit", year: "2-digit" });
  }

  function getDateTime(timestamp) {
    const date = new Date(timestamp);
    return date.toLocaleString("es-AR", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }

  const creaPaseDeSalida = (datoPasado) => {
//     console.log(datoPasado)
    const datoPase = {
      
      fechaHoraSalida: datoPasado.iniciaCondicion,
      fechaHoraRegreso: datoPasado.finalizaCondicion,
      cadeteDni: datoPasado.cadeteDni,
      tipo: "Sanidad",
      sede: datoPasado.cadeteSede,
      carpetaMedicaId: datoPasado.id
    };
    setDatosPase(datoPase);
    setModalCreaPase(true);
  };

  const carpetasFiltradas = carpetas?.filter((item) => {
    if (filtroFecha === "hoy") {
      return getTimestamp(item.fechaSolicitud).includes(getTodayDate());
    }
    return true;
  });

  const ordenarPorCampo = (campo) => {
    if (ordenCampo === campo) {
      setOrdenAscendente(!ordenAscendente);
    } else {
      setOrdenCampo(campo);
      setOrdenAscendente(true);
    }
  };

  const carpetasOrdenadas = [...carpetasFiltradas].sort((a, b) => {
    if (!ordenCampo) return 0;

    let valorA, valorB;

    switch (ordenCampo) {
      case "cadete":
        valorA = a.cadete?.cadeteApellido || "";
        valorB = b.cadete?.cadeteApellido || "";
        break;
      case "dni":
        valorA = a.cadeteDni || "";
        valorB = b.cadeteDni || "";
        break;
      case "compania":
        valorA = a.cadete?.Seccion?.Compania?.nombre || "";
        valorB = b.cadete?.Seccion?.Compania?.nombre || "";
        break;
      case "fecha":
        valorA = new Date(a.fechaSolicitud);
        valorB = new Date(b.fechaSolicitud);
        break;
      default:
        return 0;
    }

    if (typeof valorA === "string") {
      return ordenAscendente ? valorA.localeCompare(valorB) : valorB.localeCompare(valorA);
    } else {
      return ordenAscendente ? valorA - valorB : valorB - valorA;
    }
  });

  const exportarAExcel = () => {
    const datos = carpetasOrdenadas.map((item, index) => ({
      "#": index + 1,
      "Apellido y Nombre": `${item.cadete.cadeteApellido}, ${item.cadete.cadeteNombre}`,
      "DNI": item.cadeteDni,
      "Compañía": item.cadete?.Seccion?.Compania?.nombre || "",
      "Fecha Solicitud": getDateTime(item.fechaSolicitud),
      ...(paso === 2 && {
        "Diagnóstico": item.tipoDiagnostico,
        "Desde": item.iniciaCondicion ? getTimestamp(item.iniciaCondicion) : "-",
        "Hasta": item.finalizaCondicion ? getTimestamp(item.finalizaCondicion) : "-",
        "Sede": item.cadeteSede,
        "¿Generado?": item.paseDeSalidaId ? "✔" : "No"
      })
    }));

    const hoja = XLSX.utils.json_to_sheet(datos);
    const libro = XLSX.utils.book_new();
    const fechaHoy=new Date()
    XLSX.utils.book_append_sheet(libro, hoja, "Carpetas");
    XLSX.writeFile(libro, "carpetas"+fechaHoy.toLocaleDateString()+"_"+fechaHoy.toLocaleTimeString()+".xlsx");
  };

  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <button className="btn btn-success" onClick={exportarAExcel}>Descargar</button>

      {carpetas && carpetas.length > 0 ? (
        <div style={{ width: "100%", overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th>#</th>
                <th style={{ cursor: "pointer" }} onClick={() => ordenarPorCampo("cadete")}>Cadete</th>
                <th style={{ cursor: "pointer" }} onClick={() => ordenarPorCampo("dni")}>Dni</th>
                <th style={{ cursor: "pointer" }} onClick={() => ordenarPorCampo("compania")}>Compañia</th>
                <th style={{ cursor: "pointer" }} onClick={() => ordenarPorCampo("fecha")}>Fecha Solicitud</th>
                {paso == 1 && <th>Examinar</th>}
                {paso == 2 && (
                  <>
                    <th>Recomienda</th>
                    <th>Desde</th>
                    <th>Hasta</th>
                    <th>Sede</th>
                    <th>Info</th>
                    <th>Generar</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {carpetasOrdenadas.map((item, index) => (
                <tr key={item.id} style={{ backgroundColor: index % 2 === 0 ? "#f2f2f2" : "white", fontSize: "12px" }}>
                  <td>{index + 1}</td>
                  <td>{item.cadete.cadeteApellido}, {item.cadete.cadeteNombre}</td>
                  <td>{item.cadeteDni}</td>
                  <td>{item.cadete?.Seccion?.Compania?.nombre}</td>
                  <td>{getDateTime(item.fechaSolicitud)}</td>
                  {paso == 1 && (
                    <td className="btn btn-success" onClick={() => onClick(item)}>Examinar</td>
                  )}
                  {paso == 2 && (
                    <>
                      <td>{item.tipoDiagnostico}</td>
                      <td>{item.iniciaCondicion ? getTimestamp(item.iniciaCondicion) : "-"}</td>
                      <td>{item.finalizaCondicion ? getTimestamp(item.finalizaCondicion) : "-"}</td>
                      <td>{item.cadeteSede}</td>
                      <td className="btn btn-success" onClick={() => carpetaFinal(item)}>X</td>
                      <td>
                        {item.otorgaPaseSalida ? (
                          item.paseDeSalidaId ? (
                            <div>Generado ✔</div>
                          ) : comprueboPermisos(Usuario.funcion, "Crea Pases") ? (
                            <div className='btn btn-primary' onClick={() => creaPaseDeSalida(item)}>Generar</div>
                          ) : (
                            "Sin Permiso"
                          )
                        ) : "❌"}
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p>-</p>
      )}

      {modalCreaPase && (
        <ModalCreaPase isOpen={modalCreaPase} onClose={manejaCerradoPaseForm}>
          <div style={{ padding: "20px", width: "500px" }}>
            <h3>Crear Pase de Salida</h3>
            <GenerarPaseDeSalida datos={datosPase} datosCarpeta={datosPase} onClose={manejaCerradoPaseForm} />
          </div>
        </ModalCreaPase>
      )}
    </div>
  );
};

export default ListeaCarpetas;
